/* eslint-disable */

import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { io } from 'socket.io-client';
import { BaseURL, apiUrl, capitalizeEachWord } from '../config/apiUrl';
import { signOutRequest, updateUser } from '../store/auth/authSlice';
import { Get } from '../Axios/AxiosFunctions';
import { getUniqueBrowserId } from '../utils/helpers';
import {
  addSingleRealtime__propertyProjectsAndEvents,
  setAllCompareList,
  setAllFavorite,
  setAllInquiryMessageAndRequest,
  setAllSavedSearch,
  setSinglePropertyProjectsAndEvents
} from '../store/notification/notificationSlice';

// Create a new context for the socket connection
const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const socket = useRef(null);
  const dispatch = useDispatch();
  const { user, accessToken, fcmToken } = useSelector((state) => state?.authReducer);

  // get user data

  const getUserData = async () => {
    const url = BaseURL('users/me');
    const response = await Get(url, accessToken);
    if (!!response) {
      dispatch(updateUser(response?.data?.data?.user));
    }
  };

  // get my unread notifications
  const getUnreadNotifications = async () => {
    const url = BaseURL('notification/unread/all');
    const response = await Get(url, accessToken);
    if (response) {
      //! dispatch(setAllNotificationsCount(response?.data?.data));
    }
  };

  useEffect(() => {
    if (accessToken) {
      const initSocket = async () => {
        socket.current = io(apiUrl, { transports: ['websocket'] });
        // get socket id
        socket.current.on('connect', () => {
          console.warn('Active Socket Data 🤷‍♂️🤷‍♂️🤷‍♂️', {
            socketId: socket.current.id,
            deviceId: getUniqueBrowserId(),
            userId: user?._id
          });
        });

        // **************** Establish connection with socket Start ****************
        socket.current.emit('join', {
          userId: user?._id,
          deviceId: getUniqueBrowserId()
        });
        // **************** Establish connection with socket End ****************

        //! **************** Block User Start ****************
        socket.current.on('block-user', (event) => {
          if (event?._id === user?._id) {
            socket.current.emit('logout', user?._id, fcmToken, getUniqueBrowserId());
            dispatch(signOutRequest());
            localStorage.removeItem('uniqueBrowserId');
            //! navigateToHome();
            socket.current.close();
          }
        });
        //! **************** Block User End ****************

        // **************** Notification Listener Start ****************
        socket.current.on('new-notification', (data) => {
          console.warn('notification 🐉🐉🐉 ', data);
          if (data?.receiver?.includes(user?._id)) {
            // check for notification flag
            if (
              ['property', 'event', 'project', 'follow-unfollow', 'package-upgrade'].includes(
                data?.flag
              )
            ) {
              dispatch(setSinglePropertyProjectsAndEvents(data));
              const senderName = data?.sender?.companyName?.en || data?.sender?.agentName?.en;
              flag !== 'follow-unfollow' &&
                toast.info(`${capitalizeEachWord(senderName)} has created a new ${data?.flag}.`);

              if (['/notifications'].includes(window.location.pathname)) {
                dispatch(addSingleRealtime__propertyProjectsAndEvents(data));
              }
              // if(data?.flag)
            }

            //! getUnreadNotifications();
          }
        });
        socket.current.on('new-favorite', (data) => {
          console.warn('favorite 🐉🐉🐉 ', data);
          if (data?.receiver === user?._id) {
            dispatch(setAllFavorite(data?.favorite));

            //! getUnreadNotifications();
          }
        });
        socket.current.on('new-saved-search', (data) => {
          console.warn('new-saved-search 🤣🤣🤣 ', data);
          if (data?.receiver === user?._id) {
            dispatch(setAllSavedSearch(data?.savedSearches));

            //! getUnreadNotifications();
          }
        });
        socket.current.on('new-compare', (data) => {
          if (data?.receiver === user?._id) {
            dispatch(setAllCompareList(data?.compareList));
          }
        });
        socket.current.on('new-inquiry', (data) => {
          console.warn('new-inquiry 😢😢😢 ', data);
          if (data?.receiver === user?._id) {
            dispatch(setAllInquiryMessageAndRequest(data?.inquiryMessageAndRequest));

            //! getUnreadNotifications();
          }
        });
        socket.current.on('package-purchased', (data) => {
          getUserData();
        });
        // **************** Notification Listener End ****************
      };
      initSocket();
    }
  }, [accessToken, dispatch, user?._id]);

  // Provide the socket connection to children
  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};

// Custom hook to access the socket connection
export const useSocket = () => {
  return useContext(SocketContext);
};
